import { Language, SavingEvent } from '@vae/server/dist/client'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { TFunction } from 'i18next'
import { parseWeekDay } from '../../../../modules/consumptionDataParser'

dayjs.extend(isoWeek)

const weekFormat = 'DD.MM'
const dateFormat = 'DD.MM.YYYY'

export const groupEventsByDate = (
	events: SavingEvent[],
	lng: Language,
	t: TFunction<'common'>
): Record<string, SavingEvent[]> => {
	return events.reduce((acc: Record<string, SavingEvent[]>, event) => {
		const time = dayjs(event.date)
		const now = dayjs()
		const diffDays = time.startOf('day').diff(now.startOf('day'), 'days')

		let groupKey: string

		if (event.periodType === 'week' && event.weekStart) {
			const weekStart = dayjs(event.weekStart)
			const weekEnd = weekStart.add(6, 'days')
			groupKey = `${weekStart.format(weekFormat)} - ${weekEnd.format(dateFormat)}`
		} else if (diffDays === 0) {
			groupKey = t('today')
		} else if (diffDays === -1) {
			groupKey = t('yesterday')
		} else {
			const isSameWeek = time.isoWeek() === now.isoWeek() && time.year() === now.year()

			groupKey = isSameWeek ? parseWeekDay(time.isoWeekday(), lng) : time.format(dateFormat)
		}

		if (!acc[groupKey]) {
			acc[groupKey] = []
		}

		acc[groupKey].push(event)

		return acc
	}, {})
}
